import * as React from 'react';

function MalariaSetting() {
    return (
        <>
            <div style={{
                textAlign: 'left'
            }}>
                Malaria
            </div>
        </>
    )
}

export default MalariaSetting;